/**
 * @file: InspectionSiteType.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
export enum InspectionSiteType {
  Default = 1,
  Facade = 2,
  Dashboard = 3,
  TroubleLight = 4,
  Record = 5,
}

export const InspectionSiteTypeValueSet = new Set([
  InspectionSiteType.Default,
  InspectionSiteType.Facade,
  InspectionSiteType.Dashboard,
  InspectionSiteType.TroubleLight,
  InspectionSiteType.Record,
]);
